module.exports = __webpack_public_path__ + "static/fonts/Mont-HeavyItalic.2cbe249.woff";